import React from "react"
import { W0, W1 } from "@components"
import { Disclaimer } from "@components/Text"
import { TYPE_RADIO, TYPE_NONE, TYPE_HIDDEN, TYPE_DATETIME } from "@components/Form"

const LABEL_SEND_NO = "Do not send"
const LABEL_SEND_YES = "Schedule for"
const LABEL_DATETIME = "Date & Time"
const LABEL_NOTIFICATIONS = "Notifications"
const LABEL_TYPE = "Type"
const LABEL_TYPE_PLACEHOLDER = "Select document type"
const LABEL_NOTIFICATIONS_DISCLAIMER_PROJECT = "Notifications are disabled for project files."
const LABEL_NOTIFICATIONS_DISCLAIMER_INVESTOR = "Notifications are disabled for investor files."


const getInputs = (
  sentAt,
  isSent,
  typeOptions,
  hasScheduleOption,
  isProjectFileBatch,
  customTemplateInputs
) => {
  const commonInputProps = {
     size: "medium",
  }

  const shouldSchedule = !isSent

  const scheduledAtProps = !shouldSchedule
    ? { type: TYPE_NONE }
    : {
        type: TYPE_DATETIME,
        label: LABEL_DATETIME,
        required: true,
        itemProps: {
          style: { marginBottom: W1 },
        },
        inputProps: {
          minuteStep: 15,
          showNow: true,
          ...commonInputProps,
        }
      }

  const items = [
    {
      name: "name",
    },
    {
      name: "date",
      type: TYPE_HIDDEN
    },
    {
      name: "documentType",
      label: LABEL_TYPE,
      options: typeOptions,
      required: true,
      placeholder: LABEL_TYPE_PLACEHOLDER,
      hasAutoComplete: true,
    },
  ]

  if (sentAt) {
    return [
      ...items,
      {
        name: "isSent",
        type: TYPE_NONE,
      },
      {
        name: "scheduledAt",
        type: TYPE_NONE,
      },
      ...customTemplateInputs,
    ]
  }

  const disclaimer = isProjectFileBatch
    ? LABEL_NOTIFICATIONS_DISCLAIMER_PROJECT
    : LABEL_NOTIFICATIONS_DISCLAIMER_INVESTOR

  items.push(
    {
      name: "isSent",
      type: TYPE_RADIO,
      label: LABEL_NOTIFICATIONS,
      initialValue: true,
      options: [
        {
          value: true,
          label: LABEL_SEND_NO,
          disabled: !hasScheduleOption,
        },
        {
          value: false,
          label: LABEL_SEND_YES,
          disabled: !hasScheduleOption,
        },
      ],
      itemProps: {
        style: { marginBottom: W1 },
        extra: hasScheduleOption
          ? undefined
          : <Disclaimer text={disclaimer} style={{ marginTop: W0 }} />
      },
    },
    {
      name: "scheduledAt",
      label: "",
      ...scheduledAtProps,
    },
    ...customTemplateInputs,
  )

  return items
}

export default getInputs
